import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Panel,
  PanelType,
  PrimaryButton,
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
} from 'office-ui-fabric-react';
import { useBoolean } from '@uifabric/react-hooks';
import { useDispatch } from 'react-redux';
import styles from './ScopeFiltersForm.style';
import TextButton from '../TextButton';
import ContractFilterForm from '../ContractFilterForm/ContractFilterForm';
import { patchContractFilters } from '../../actions/contracts';
import { showFlashMessage } from '../../actions/ui';

const dialogContentProps = {
  type: DialogType.normal,
  title: 'Pausing Contract',
  subText: 'This action will pause the contract. Are you sure you would like to continue?',
};

const ScopeFiltersForm = ({ contract }) => {
  const dispatch = useDispatch();
  const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] = useBoolean(false);
  const [dialogHidden, { setTrue: hideDialog, setFalse: showDialog }] = useBoolean(true);
  const [formScopeFilters, setScopeFilters] = useState();
  const isEditMode = contract?.scopeFilter?.filters?.length > 0;

  const formRef = useRef();

  const submitToApi = async scopeFilters => {
    const response = await dispatch(patchContractFilters(contract.address, scopeFilters));
    if (response.error) {
      dispatch(
        showFlashMessage(response.payload?.message || 'Error updating filters', {
          type: 'error',
          duration: 10000,
        }),
      );
    } else {
      dispatch(
        showFlashMessage('Successfully updated filters.', {
          type: 'success',
          duration: 10000,
        }),
      );
    }
    dismissPanel();
  };

  const onSubmitFilters = scopeFilters => {
    if (contract.approvalStatus.toLowerCase() === 'approved') {
      setScopeFilters(scopeFilters);
      showDialog();
    } else {
      submitToApi(scopeFilters);
    }
  };

  const handleSubmit = async () => {
    await formRef.current.submitForm();
  };

  const renderFooterContent = () => {
    return (
      <div className={styles.buttonContainer}>
        <TextButton onClick={dismissPanel}>Cancel</TextButton>
        <PrimaryButton onClick={handleSubmit}>Save and Continue</PrimaryButton>
      </div>
    );
  };

  return (
    <div className={styles.buttonContainer}>
      <TextButton className={styles.addFilterButton} onClick={openPanel}>
        {isEditMode ? `Edit Filters` : `Add a Filter`}
      </TextButton>

      <Panel
        isOpen={isOpen}
        onDismiss={dismissPanel}
        type={PanelType.smallFluid}
        closeButtonAriaLabel="Close"
        headerText="Add a Filter"
        className={styles.panelHeading}
        onOuterClick={() => {}}
        isFooterAtBottom
        onRenderFooterContent={renderFooterContent}
      >
        <ContractFilterForm
          onSubmit={onSubmitFilters}
          onCancel={dismissPanel}
          ref={formRef}
          effectiveDate={contract.effectiveDate}
          terminationDate={contract.terminationDate}
          scopeFilter={contract.scopeFilter}
        />
      </Panel>
      <Dialog hidden={dialogHidden} dialogContentProps={dialogContentProps}>
        <DialogFooter>
          <PrimaryButton
            text="Continue"
            onClick={() => {
              hideDialog();
              submitToApi(formScopeFilters);
            }}
          />
          <DefaultButton
            text="Cancel"
            onClick={() => {
              hideDialog();
            }}
          />
        </DialogFooter>
      </Dialog>
    </div>
  );
};

ScopeFiltersForm.propTypes = {
  contract: PropTypes.object,
};

ScopeFiltersForm.defaultProps = {
  contract: null,
};

export default ScopeFiltersForm;
